import { AxiosError, AxiosResponse } from 'axios';
import { useMutation, UseMutationResult, useQueryClient } from 'react-query';
import { AthletePackageCreate, AthletePackageCreateResponse, ErrorMessage } from 'types';
import { client } from 'utils/api-client';

export default function useCreateAthletePackage(): UseMutationResult<
  AxiosResponse<AthletePackageCreateResponse>,
  AxiosError<ErrorMessage>,
  AthletePackageCreate
> {
  const queryClient = useQueryClient();

  const createAthletePackage = (
    athletePackage: AthletePackageCreate,
  ): Promise<AxiosResponse<AthletePackageCreateResponse>> => {
    return client.post('athlete-packages/', athletePackage);
  };

  return useMutation(createAthletePackage, {
    onSuccess: response => {
      queryClient.invalidateQueries('athletePackages');
      queryClient.invalidateQueries('salesPortalPackages');
      queryClient.invalidateQueries('packages');
      queryClient.invalidateQueries('athleteSalesPortalPackages');
      queryClient.invalidateQueries('athleteSalesPortalPackage');
      queryClient.invalidateQueries({
        queryKey: ['athletes', response.data.athlete],
      });
      queryClient.invalidateQueries({
        queryKey: ['athleteStatuses', response.data.athlete],
      });
    },
    onError: () => {
      queryClient.invalidateQueries('paymentMethods');
    },
  });
}
